module.exports = __webpack_public_path__ + "img/spring.f3a819d6.jpg";